module.exports = __webpack_public_path__ + "static/img/IMG_20170301_171212.39dc775f.jpg";